/* Shared scroll-reveal for the custom-* sections.
   Contract: wrappers carry [data-csr]; each section's own CSS defines the
   hidden state gated on html.csr-ready and resolves it on .is-inview. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('is-inview');
  }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-csr]:not(.is-inview)');
    if (!els.length) return;

    if (
      reduce ||
      (window.Shopify && window.Shopify.designMode) ||
      !('IntersectionObserver' in window)
    ) {
      els.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

/* Site-wide anchor scroll, so every in-page "#section" link (footer,
   nav, buttons, etc.) behaves like the hero's "Shop the brushes" button:
   smooth-scrolls and clears the fixed navbar using its live published
   height (--gh-h), instead of a raw jump that tucks the target under it. */
(function () {
  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--gh-h');
    var h = parseFloat(raw);
    return (isNaN(h) ? 78 : h) + 24;
  }

  function goTo(target, smooth) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(top, 0), behavior: smooth ? 'smooth' : 'auto' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  // Arriving from another page with a hash in the URL (e.g. the footer's
  // "All brush packs" link from a non-home page): the browser's native jump
  // already happened by the time scripts run, landing the target under the
  // fixed navbar. Correct it once the layout has settled.
  if (window.location.hash) {
    window.addEventListener('load', function () {
      var target = document.getElementById(window.location.hash.slice(1));
      if (target) goTo(target, false);
    });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;

    var link = e.target.closest('a[href*="#"]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex < 0) return;

    var id = href.slice(hashIndex + 1);
    if (!id) return;

    var path = href.slice(0, hashIndex).replace(/\/$/, '');
    var here = window.location.pathname.replace(/\/$/, '');
    if (path && path !== here) return; // Different page — let the browser navigate there.

    var target = document.getElementById(id);
    if (!target) return; // Not an on-page anchor — let the browser handle it.

    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    goTo(target, !reduce);
    if (history.replaceState) history.replaceState(null, '', href.slice(hashIndex));
  });
})();
